/** @module SiteAdmin/SubtypedViewMixin */
define([
	"dojo/_base/declare",
	"csi/config",
	"csi/core/ExtendedPath",
	"csi/def",
	"csi/reflection",
	"csi/resolver"
], function(declare, config, ExtendedPath, def, reflection, resolver) {

	return declare(null, {
		/** @property {ExtendedPath} extendedPathToSubtypedClass - extended path to subtyped class owning this view */
		extendedPathToSubtypedClass: null,

		/** @property {C8AttributeId} subtypeOptionalSetting - setting containing subtype's map of optional attributes */
		subtypeOptionalSetting: null,

		/**
		 * @override
		 * Make custom view container specific to subtype
		 */
		_resolveView() {
			const {defView, prefKey} = this;
			const targetClass = defView.getPageClass();
			const subtypeName = this.getViewSubtypeName();

			if (subtypeName && !prefKey) {
				this.prefKey = defView.getKey(subtypeName);
			}

			this.extendedPathToSubtypedClass = ExtendedPath.getParentPathToSubtypedClass(targetClass);
			this.inherited(arguments);
		},

		/**
		 * Return optional attributes map from subtype settings
		 * @return {Record<C8AttributeId, boolean> | undefined}
		 */
		getViewOptionalAttributes() {
			const {subtypeOptionalSetting} = this;
			const node = this.getViewSubtypeNode();

			if (node && subtypeOptionalSetting) {
				return reflection.getSubtypeSetting(node.Subtype, subtypeOptionalSetting);
			}
		},

		/**
		 * Retrieves the subtype name from either the root node or the custom view key
		 * @return {string | undefined}
		 */
		getViewSubtypeName() {
			const {prefKey} = this;
			const node = this.getViewSubtypeNode();

			if (node) {
				return config.getSubtypeName(node.Subtype);
			} else if (prefKey) {
				// this case can happen when running custom view migration without node instance
				return def.decomposeViewKey(prefKey).context;
			}
		},

		/**
		 * Return the node that has the subtype
		 * @return {C8Node | undefined}
		 */
		getViewSubtypeNode() {
			return resolver.resolveSubtypedNode(this.getViewNode(), this.cacheView);
		},

		/**
		 * @override
		 * Add mapping for subtype's optional attributes
		 */
		onCustomViewAttributeOptions(options) {
			const optionalAttributes = this.getViewOptionalAttributes();
			if (optionalAttributes) {
				options.optionalAttributesMaps = {[this.extendedPathToSubtypedClass.value]: optionalAttributes};
			}

			this.inherited(arguments);
		},
	});
});